import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full py-8 mt-12 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-xs text-slate-400 text-center">
          EVUpgrades.co is a participant in various affiliate programs. We may earn a commission on qualifying purchases made through our links.
        </p>
        <p className="text-xs text-slate-500 text-center mt-2">
          © {new Date().getFullYear()} EV Upgrades. All rights reserved. | <Link to="/terms" className="hover:text-slate-500 transition-colors">Terms of Service</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;